<template>
    <div id="hello">
        <div id="render-wrapper">
            <Render v-bind:isDay="isDay"></Render>
            <button v-on:click="isDay = !isDay" id="toggle-day-night" class="button">Front / Tył</button>
        </div>

        <h1 id="main-title">
            Zieleń i przestrzeń – korzystna lokalizacja
        </h1>


        <div id="content" style="padding-bottom: 4em;">




            <section class="section">
                <div class="container  is-fluid">
                    <div class="columns">
                        <div class="column is-two-fifths">
                            <a @click="index = 0"><img :src="photos[0]"   v-animate-onscroll="'animated'" class="fadeInDown"></a>
                            <p class="subtitle"></p>
                        </div>
                        <div class="column is-three-fifths">
                            
                            <p>„Kaczeńcova” to nie tylko świetne miejsce do życia, ale i doskonała i trwała inwestycja kapitału, m.in. ze względu na dobrą lokalizację. Budynek znajduje się w atrakcyjnej dzielnicy, nieopodal rozległego wąwozu. Zielone tereny z pewnością zachęcą mieszkańców do rekreacji na świeżym powietrzu: spacerów z bliskimi, treningów czy samotnych, wyciszających wędrówek.
</p>
<p>
Nieopodal inwestycji znajdują się przystanki autobusowe, pełna infrastruktura handlowo-usługowa, w tym sklepy wielobranżowe, lokale gastronomiczne, gabinety lekarskie, apteki, salony fryzjerskie i kosmetyczne. Przyszli mieszkańcy będą mieli do dyspozycji również placówki opiekuńczo-wychowawcze i edukacyjne, stacje paliw, siłownie, kościół, pocztę, parkingi, jak również sklepy spożywcze. Umożliwi im to załatwianie codziennych spraw bez konieczności nadmiernego przemieszczania się po mieście. Nie oznacza to bynajmniej, że takowe nie będzie możliwe. Dzielnica jest bardzo dobrze skomunikowana, a co za tym idzie, zapewnia duży komfort w podróżowaniu.
</p>
<p><strong>
„Kaczeńcova” będzie doskonałym wyborem dla tych, którzy cenią sobie świetną jakość, funkcjonalność i wygodę.</strong></p>
                        </div>
                    </div>

                </div>
            </section>

            <section class="section">
                <div class="container  is-fluid">
                    <div class="columns" style="flex-direction: row-reverse;">
                        <div class="column is-two-fifths">
                            <a @click="index = 0"><img :src="photos[1]"   v-animate-onscroll="'animated'" class="fadeInDown"></a>
                            <p class="subtitle"></p>
                        </div>
                        <div class="column is-three-fifths">
                            
                            <p>
                                <strong>Inwestycja położona jest w bezpośredniej bliskości ul. Orkana.</strong>
                                <br>Odległości od wybranych miejsc:
                            </p>
                            <ul>
                                

                                <ul>
                                    <li>SPA Orkana: 280 m</li>
                                    <li>Stokrotka: 450 m</li>
                                    <li>Biedronka: 350m</li>
                                    <li>Luxmed: 250 m</li>
                                    <li>Przedszkole: 450m</li>
                                    <li>Szkoda podstawowa: 1 km</li>
                                    <li>Liceum: 500 m</li>
                                    <li>Stacja paliw: 1km</li>
                                    <li>Kościół: 400m</li>
                                    <li>Przystanki: 300m</li>
                                    <li>Multimedialna biblioteka: 400m</li>
                                    <li>Galerie handlowe: 500 m </li>
                                    <li>w pobliżu inwestycji znajduje się również ścieżka rowerowa, którą łatwo można się dostać do Starego Gaju i Zalewu Zemborzyckiego</li>
                                </ul>



                               
                            </ul>
                        </div>
                    </div>

                </div>
            </section>

            <hr>

            <section class="section">
                <div class="container  is-fluid">
                    <div class="columns">
                        <div class="column is-full" style="text-align: center;">
                            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1npDYJNpFPviAmOD8FNU7Im5FoUBWL0Q&ehbc=2E312F&noprof=1" height="480" style="width: 100%; height: 480px;"></iframe>
                           <br><br><br><hr><br><br><br>
                           <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2498.299678880955!2d22.499952876301858!3d51.23197553078707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNTHCsDEzJzU1LjEiTiAyMsKwMzAnMDkuMSJF!5e0!3m2!1spl!2spl!4v1693394007866!5m2!1spl!2spl" height="350" frameborder="0" style="border:0; width: 100%; filter: grayscale(100)" allowfullscreen="" aria-hidden="false" tabindex="0" ></iframe> 
                        </div>
                    </div>

                </div>
            </section>





        </div>

        <CoolLightBox
                :items="photos"
                :index="index"
                @close="index = null">
        </CoolLightBox>
    </div>
</template>

<script>
    import Render from "../components/Render";
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                isDay: false,
                photos: [ require('@/assets/img/3_Post.jpg'),
                            require('@/assets/img/4_Post.jpg')],
                index: null
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            }
        },

        components: {
            Render: Render, CoolLightBox
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
